var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXamarin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 260,
    viewBox: "0 0 260 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_21_12)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 36,
    width: 180,
    height: 180,
    rx: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 36.5,
    width: 179,
    height: 179,
    rx: 31.5,
    stroke: "#D9D9D9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.933 69C99.4762 69.0073 96.0921 70.9697 94.3519 73.9633L67.2849 120.982C65.5717 123.983 65.5717 127.907 67.2849 130.908L94.3519 177.927C96.0923 180.92 99.4762 182.883 102.933 182.89H157.067C160.524 182.882 163.908 180.92 165.648 177.927L192.715 130.908C194.428 127.907 194.428 123.983 192.715 120.982L165.648 73.9633C163.908 70.9697 160.524 69.0068 157.067 69H102.933ZM103.424 96.5063C103.499 96.499 103.577 96.499 103.651 96.5063H112.989C113.402 96.5149 113.803 96.7537 114.009 97.1125L129.849 125.339C129.929 125.478 129.98 125.634 129.999 125.793C130.019 125.634 130.07 125.478 130.15 125.339L145.952 97.1125C146.165 96.7429 146.584 96.5027 147.01 96.5063H156.347C157.174 96.5136 157.793 97.5551 157.406 98.287L141.945 125.945L157.406 153.565C157.83 154.301 157.196 155.391 156.347 155.383H147.01C146.577 155.38 146.155 155.123 145.952 154.739L130.15 126.513C130.07 126.374 130.019 126.218 129.999 126.059C129.98 126.218 129.929 126.374 129.849 126.513L114.009 154.739C113.812 155.112 113.409 155.366 112.989 155.383H103.651C102.803 155.391 102.169 154.301 102.593 153.565L118.054 125.945L102.593 98.287C102.222 97.6192 102.675 96.6489 103.424 96.5063Z",
    fill: "#3498DB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_21_12",
    x: 0,
    y: 0,
    width: 260,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0367917 0 0 0 0 0.0348958 0 0 0 0 0.0484375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_21_12"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_21_12",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXamarin);
export default __webpack_public_path__ + "static/media/xamarin.fcebf7798a5935d233e82f230982eeb0.svg";
export { ForwardRef as ReactComponent };